<script lang="ts">
	interface Props {
		level?: string;
		className?: string;
		fontClasses?: string;
		children?: import('svelte').Snippet;
	}

	let {
		level = '1',
		className = '',
		fontClasses = 'font-title font-extralight',
		children
	}: Props = $props();

	let font = $derived.by(() => {
		switch (level) {
			case '1':
				return 'xl:text-4xl text-3xl';
			case '2':
				return 'xl:text-2xl text-xl';
			case '3':
				return 'xl:text-xl text-lg';
			case '4':
				return 'xl:text-lg text-base';
			default:
				return '';
		}
	});
</script>

<h1 class="{fontClasses} {font} {className}">
	{@render children?.()}
</h1>
